import { Suspense, useState } from "react";
import { IoClose } from "react-icons/io5";
import { Link, Outlet, useNavigate, useOutletContext, useParams } from "react-router";
import styled from "styled-components";

import * as UI from "~/src/modules/ui-kit";

import useBrands from "../../../clients/brands/useBrands";
import {
    confirmUnsavedChanges,
    type UnsavedChangesContext,
} from "../../../modules/unsaved-changes";


export default function Brands() {
    const [token, setToken] = useState("");

    const { brandID } = useParams();

    const guard = useOutletContext<UnsavedChangesContext>();

    return (
        <>
            <Styled>
                <UI.HeroInputField>
                    <div>
                        <UI.HeroInput
                            autoFocus={ !brandID }
                            onChange={ setToken }
                            placeholder="Search"
                            value={ token }
                        />
                        <button
                            onClick={ () => setToken("") }
                            type="reset"
                        >
                            <IoClose />
                        </button>
                    </div>
                    <span>search Brands by name</span>
                </UI.HeroInputField>
                <UI.A as={ Link } to="./new">create new brand</UI.A>
                <Suspense fallback={ <span>loading</span> }>
                    <BrandList token={ token } guard={ guard } />
                </Suspense>
            </Styled>
            <Outlet context={ guard satisfies UnsavedChangesContext } />
        </>
    );
}

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
    transition: opacity 200ms;

    ${ UI.HeroInput } {
        font-size: 2.4em;
    }

    ol {
        display: flex;
        flex-direction: column;
        gap: 8px;
        list-style: none;
        margin: 0;
        padding: 0;

        a {
            color: #000;
            font-size: 1.2rem;
            overflow: hidden;
            position: relative;
            text-decoration: none;
            text-overflow: ellipsis;
            white-space: nowrap;

            ${ UI.FluidAccent2 }

            &:hover {
                text-decoration: none;
            }
        }
    }
`;

function BrandList(props) {
    const { token, guard } = props;

    const navigate = useNavigate();
    const { brandID } = useParams();

    async function handleSelect(event, id: string) {
        event.preventDefault();
        if (id === brandID) return;
        if (await confirmUnsavedChanges(guard)) navigate(id);
    }

    const allBrands = useBrands();

    const brands = allBrands
        .data
        .brands
        .filter(
            (brand) => [
                brand.id === token,
                brand.name?.toLowerCase?.()?.includes?.(token.toLowerCase()),
                brand.legacyAlias?.toLowerCase?.()?.includes?.(token.toLowerCase()),
                brand.legacyID === token,
            ].some(Boolean)
        )
        .sort(
            (a, b) => a.name?.localeCompare?.(b.name)
        );

    if (!brands.length) return <span>no brands</span>;

    return (
        <ol>
            {
                brands.map(
                    (brand) => (
                        <li key={ brand.id }>
                            <a
                                href={ brand.id }
                                onClick={ (event) => handleSelect(event, brand.id) }
                            >{ brand.name }</a>
                        </li>
                    )
                )
            }
        </ol>
    );
}
